<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ title_page }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.notifications.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <h4>{{ $t('current') }}</h4>
                            </CCardHeader>
                            
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.notifications.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.notifications.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.notifications.rows"
                                    :loading="tables.notifications.loading"
                                    @row-clicked="markAsReaded"
                                    striped
                                    hover
                                    pagination
                                >
                                    <template #no-items-view>
                                        <div class="block-no-items section">
                                            <h2
                                                class="
                                                    section__title
                                                    text-no-items
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "you_have_no_notifications"
                                                    )
                                                }}
                                            </h2>
                                        </div>
                                    </template>
                                    <template #id="{ item }">
                                        <td>
                                            {{ item.id }}
                                        </td>
                                    </template>

                                    <template #title="{ item }">
                                        <td>
                                            {{ item.title }}
                                            <CBadge
                                                v-if="item.readed == 0"
                                                color="success"
                                            >
                                                {{ $t("read") }}
                                            </CBadge>
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/notification.api/list"
                                                :table="tables.notifications"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.notifications.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePaginationCurrentNotifications"
                                    :activePage="tables.notifications.page"
                                    :pages="tables.notifications.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.notifications.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                 <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <h4>{{ $t('previous') }}</h4>
                                
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.previousNotifications.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.previousNotifications.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :items-per-page="tables.previousNotifications.rows"
                                    :loading="tables.previousNotifications.loading"
                                    @row-clicked="markAsReaded"
                                    striped
                                    hover
                                    pagination
                                >
                                    <template #no-items-view>
                                        <div class="block-no-items section">
                                            <h2
                                                class="
                                                    section__title
                                                    text-no-items
                                                "
                                            >
                                                {{
                                                    $t(
                                                        "you_have_no_notifications"
                                                    )
                                                }}
                                            </h2>
                                        </div>
                                    </template>
                                    <template #id="{ item }">
                                        <td>
                                            {{ item.id }}
                                        </td>
                                    </template>

                                    <template #title="{ item }">
                                        <td>
                                            {{ item.title }}
                                            <CBadge
                                                v-if="item.readed == 0"
                                                color="success"
                                            >
                                                {{ $t("read") }}
                                            </CBadge>
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/notification.api/list"
                                                :table="tables.previousNotifications"
                                                :adapterFilters="adapterQueryPreviousNotifications"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.previousNotifications.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePaginationPreviousNotifications"
                                    :activePage="tables.previousNotifications.page"
                                    :pages="tables.previousNotifications.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import {
    cilPlus,
    cilSettings,
    cilReload,
    cilPencil,
    cilChart,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import {
    getIntervalDateCurrentWeek
} from "~/utils/date.js";
import NotificationsTable from "~/pages/app/notifications/tables/notifications";
import PreviousNotificationsTable from "~/pages/app/notifications/tables/previousNotifications";

export default {
    name: "NotificationsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonExport, 
        FilterFields 
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
        cilReload,
        cilChart,
    },
    data() {
        return {
            tables: {
                notifications: NotificationsTable,
                previousNotifications: PreviousNotificationsTable,
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
    },
    methods: {
        async updatePaginationCurrentNotifications(newValue) {
            this.tables.notifications.page = newValue;
             await this.updateTable({
                tableName: "notifications",
                adapterFilters: this.adapterQueryCurrentNotifications
            });
        },
        async updatePaginationPreviousNotifications(newValue) {
            this.tables.previousNotifications.page = newValue;
            await this.updateTable({
                tableName: "previousNotifications",
                adapterFilters: this.adapterQueryPreviousNotifications
            });
        },
        async updateData() {
            await this.updateTable({
                tableName: "notifications",
                adapterFilters: this.adapterQueryCurrentNotifications
            });

            await this.updateTable({
                tableName: "previousNotifications",
                adapterFilters: this.adapterQueryPreviousNotifications
            });

        },

        adapterQueryPreviousNotifications(query) {
            let { from, to } = getIntervalDateCurrentWeek();
            query.where = {
                ...query.where,
                created_at: {
                    less_than: from
                }
            }
            return query;
        },

        adapterQueryCurrentNotifications(query) {
            let { from, to } = getIntervalDateCurrentWeek();
            query.where = {
                ...query.where,
                created_at: {
                    between: [
                        from, 
                        to, 
                        false
                    ],
                },
            }
            return query;
        },

        async markAsReaded(notification){
            await this.loadData({
                url: "/notification.api/readed/" + notification.uuid,
                method: "PUT",
            });

            let route = this.generateRoute(notification);
            if(route){
                this.$router.push(route)
            }
        },

        generateRoute(notification) {
            let route = {};

            switch (notification.type) {
                case "notification.provider_event_capping":
                    route = {
                        ...route,
                        path: "/app/campaings",
                    }
                    this.$store.dispatch('page/addFilterWhere', {
                        id: {
                            equals: notification.code
                        }
                    } );
                    break;
                case "client_integration":
                    route = {
                        ...route,
                        path: "/app/delivery_campaings",
                    }
                    this.$store.dispatch('page/addFilterWhere', {
                        id : {
                            equals: notification.code.split('|')[0]
                        }
                    } );
                default:
                    break;
            }

            return route
        }
    },
    async mounted() {
        await this.updateData();
        this.updatePageLoading(false);
    },
};
</script>

<style scoped lang="scss">
</style>